import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FlightOperatorReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/flight-operator.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FlightOperatorReducer, defaultState, asyncActions);
};

type IFlightOperatorContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FlightOperatorContext = createContext<Partial<IFlightOperatorContext>>({
  state: defaultState,
}) as React.Context<IFlightOperatorContext>;

const FlightOperatorProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FlightOperatorContext.Provider value={{ ...reducer }}>
      {children}
    </FlightOperatorContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFlightOperatorContext = () => useContext(FlightOperatorContext);

export type IUseFlightOperatorContext = ReturnType<
  typeof useFlightOperatorContext
>;

export { FlightOperatorContext, FlightOperatorProvider };
